import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {loadActiveUser} from '../../actions/ClientActions';
import LoadingIndicator from '../../components/LoadingIndicator';
import UserSidePane from '../../components/user/UserSidePane';

var unMountActiveUser = () => ({type: 'UNMOUNT_ACTIVE_USER'})

@connect(
    state => {
        var belongsToAuthUser = state.activeUser.user && state.auth.user && state.activeUser.user.id == state.auth.user.id;
        return {
            loaded: state.activeUser.loaded,
            user: state.activeUser.user,
            loggedInUser: state.auth.user,
            belongsToAuthUser,
            tasks: state.activeUser.tasks
        };
    },
    {loadActiveUser, unMountActiveUser}
)
export default class UserPage extends React.Component {
    componentDidMount() {
        this.loadActiveUser();
    }
    componentWillUnmount() {
        this.props.unMountActiveUser();
    }
    loadActiveUser(){
        var { loadActiveUser, routeParams } = this.props;

        loadActiveUser(routeParams.id);
    }

    render() {
        const { user, loggedInUser } = this.props;
        if(! this.props.loaded) {
            var loadingContainerStyle = {
                height: '500px',
                justifyContent: 'center',
                alignItems: 'center'
            };

            return (
                <div className="flex-container" style={loadingContainerStyle}>
                    <LoadingIndicator />
                </div>
            );
        }

        return (
            <div className="row">
                <ol className="breadcrumb page-breadcrumb">
                    <li><Link to="/admin/manage_users">Users</Link></li>
                    <li className="active">{user.firstName} {user.lastName}</li>
                </ol>
                <div className="col-md-4">
                    <UserSidePane user={user} loggedInUser={loggedInUser} />
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/pages/admin/UserPage.js